import axiosPost from "./axiosPost";

export const RNESRubroDel = async (credentials, data) => {
    const body = {
        service: "RNESRubroDel",
        params: {
            rnesRubroId: data?.id || null,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
